import {useRouter} from 'next/router';

import {useDashboardQuery, useStoreQuery} from '#apollo/schema';

export const useDashboardState = () => {
  const {push} = useRouter();
  const {data, loading} = useDashboardQuery({
    onCompleted({me}) {
      const labSubmissionWithResult = me?.mostRecentLabSubmissionWithResults;

      // When the user has a `labSubmission` with results, they should be
      // redirected to `/results` if:
      if (labSubmissionWithResult) {
        const labSubmissionRecord = labSubmissionWithResult.labRecord;

        // ... there is no associated `labSubmissionRecord`
        if (!labSubmissionRecord) {
          return push('/results');
        }

        // ... or, the `labSubmissionRecord` indicates they have not viewed the
        // results.
        if (labSubmissionRecord && !labSubmissionRecord.hasViewedResultStory) {
          return push('/results');
        }
      }
    },
  });

  const {currentTestPeriod, learningResources, me} = data || {};
  const {
    labSubmissions,
    mostRecentLabSubmission,
    mostRecentLabSubmissionWithResults,
    customerAccount,
    userProfile,
  } = me || {};
  const {firstName} = userProfile || {};
  const {subscription} = customerAccount || {};
  const {data: dataStore, loading: loadingStore} = useStoreQuery();
  const {store} = dataStore || {};
  const {productVariants} = store || {};

  // getting the non-member test kit variant for supplement subscribers
  const testKitVariant = productVariants?.filter(pv => pv.tid === 'pv-tk-oneoff')[0]?.id || null;
  const testKitCheckOutLink = `/shop/cart/${testKitVariant}:1`;

  // Subscription Status
  const subscriptionStatusValue = (subscription?.status || 'ACTIVE').toUpperCase();
  const displayStatusValue =
    subscriptionStatusValue === 'ACTIVE'
      ? 'ACTIVE'
      : subscription?.hasMembership
      ? 'ACTIVE'
      : subscriptionStatusValue;

  return {
    loading: loading || loadingStore,
    currentTestPeriod,
    learningResources,
    labSubmissions,
    mostRecentLabSubmission,
    mostRecentLabSubmissionWithResults,
    subscription,
    testKitCheckOutLink,
    firstName,
    hasMembership: subscription?.hasMembership ?? false,
    status: displayStatusValue,
  };
};
